import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './styles.module.scss';

import BuyButton from '../BuyButton';

class ArchiveItem extends Component {
  onEnter = () => {
    const { onOver, slug } = this.props;
    onOver(slug);
  };

  onLeave = () => {
    const { onLeave, slug } = this.props;
    onLeave(slug);
  };

  render() {
    const {
      attribution,
      buyLink,
      client,
      description,
      dimensions,
      material,
      medium,
      slug,
    } = this.props;

    const itemInfo = [
      client,
      medium,
      material,
      description,
      dimensions,
    ];
    const items = itemInfo.filter(item => !!item);

    return (
      <div
        className={styles.item}
        id={slug}
      >
        <dl>
          {
            items.map((info, index) => (
              <dt key={`${slug}${info}${index}`}>
                <Link
                  className={styles.info}
                  to={{
                    pathname: `/${slug}`,
                    state: {
                      showAll: true,
                    },
                  }}
                >
                  {info}
                </Link>
              </dt>
            ))
          }
          {attribution && (
            <dt
              key="attribution"
            >
              <a href={attribution.url} className={styles.info}>
                {attribution.label}
              </a>
            </dt>
          )}
          {buyLink && (
            <dt
              className={styles.buy}
              key="buy"
            >
              <BuyButton
                link={buyLink}
              />
            </dt>
          )}
        </dl>
      </div>
    );
  }
}

ArchiveItem.propTypes = {
  attribution: PropTypes.object,
  buyLink: PropTypes.string,
  client: PropTypes.string,
  description: PropTypes.string,
  dimensions: PropTypes.string,
  material: PropTypes.string,
  medium: PropTypes.string,
  onLeave: PropTypes.func.isRequired,
  onOver: PropTypes.func.isRequired,
  slug: PropTypes.string,
};

ArchiveItem.defaultProps = {
  attribution: null,
  buyLink: null,
  client: '',
  description: '',
  dimensions: '',
  material: '',
  medium: '',
  slug: '',
};

export default ArchiveItem;



// WEBPACK FOOTER //
// ./src/components/ArchiveItem/index.jsx